import React from 'react'
import { Button, Confirm, Dropdown, Form, Header, Icon, Message, Dimmer, Loader } from 'semantic-ui-react'
import { inlineStyle } from '../../styles/custom'
import PermissionsManager from '../PermissionsManager'

const renderRoles = (roles) => {
  let _roles = [{ value: null, text: '--' }]
  roles.forEach(role => {
    _roles.push({value: role.id, text: role.name})
  })
  return _roles
}

const UserForm = ({ user, roles, status, onChange, onSubmit, onDelete }) => {
  if (status.loading)
    return (
      <Dimmer active inverted>
        <Loader inverted>Chargement</Loader>
      </Dimmer>
    )

  let roleId = null
  if (user.roles.length > 0 && user.roles[0].id) {
    roleId = user.roles[0].id
  }

  return (
    <Form>
      <Header>Utilisateur{status.isNew ? ' : Création' : ' : Édition'}</Header>
      {status.error ? <Message negative><Message.Header>Erreur</Message.Header ><p>{status.message}</p></Message > : null}
      {!status.error && status.message ? <Message info><p>{status.message}</p></Message> : null}
      <Form.Group widths='equal'>
        <Form.Input placeholder='Nom' id='firstName' fluid label='Nom' value={user.firstName} onChange={onChange} />
        <Form.Input placeholder='Prénom' id='lastName' fluid label='Prénom' value={user.lastName} onChange={onChange} />
      </Form.Group>
      <Form.Input placeholder='Email' id='email' fluid label='Email' value={user.email} onChange={onChange} />
      <Form.Group widths='equal'>
        <Form.Input placeholder='Mot de passe' id='password' fluid label='Mot de passe' type='password' onChange={onChange} />
        <Form.Input placeholder='Mot de passe' id='password2' fluid label='Taper le mot de passe une 2ème fois' type='password' onChange={this.handleChange} />
      </Form.Group>
      <Form.Field>
        <label>Rôle</label>
        {
          roles.loading ? <div>Chargement</div> :
            <Dropdown placeholder='Sélectionnez un rôle' fluid selection closeOnChange id='role' value={roleId} options={renderRoles(roles.getRoles)} onChange={(e, data) => onChange(e, data, 'dropdown')} />
        }
      </Form.Field>
      <PermissionsManager hasPermissions={['create_user', 'update_user']}>
        {status.loading ? <Button type='submit' color='olive' loading></Button> :
          <Button type='submit' color='olive' floated='left' onClick={onSubmit}><Icon name="save" /> Sauvegarder</Button>
        }
      </PermissionsManager>
      <PermissionsManager hasPermissions={['delete_user']}>
        {!status.isNew ? (
          <div>
            <Button type='submit' color='red' floated='right' onClick={(event, data) => { onDelete(event, { confirm: true })}}><Icon name="delete" /> Suppression</Button>
          </div>
        ) : null}
      </PermissionsManager>
      <Confirm
        content='Êtes-vous sûr(e) de vouloir supprimer cet utilisateur ? Cette action est définitive.'
        open={status.deletion.confirm}
        onCancel={(event, data) => { onDelete(event, { confirm: null })}}
        onConfirm={(event, data) => { onDelete(event, { confirm: false })}}
        style={inlineStyle.modal}
        cancelButton='Annuler'
        confirmButton='Ok'
      />
    </Form>
  )
}

export default UserForm



// WEBPACK FOOTER //
// ./src/components/form/User.js